import superMeta from '../_CAT_ROOT_MODULE/metaCatRootModuleNode.mjs'

export default {
    ...superMeta,
    moduleIdProp: 'dmId',
    moduleType: 'DM',
    name: '库表域',
    type: 'CAT_ROOT_DM',
}
